import React from 'react';
import { BarChart, Trash2, Layers, Building } from 'lucide-react';
import { formatCurrency, formatNumber } from '../../../../../utils/formatting';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели для сравнения сохраненных проектов
 */
const SampleProjectsSidebar = ({ 
  savedProjects, 
  deleteSavedProject, 
  loadSavedProject 
}) => {
  // Если нет сохраненных проектов
  if (!savedProjects || savedProjects.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <Building className="w-5 h-5 mr-2 text-indigo-500" />
          Сохраненные проекты
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Здесь будут отображаться сохраненные проекты для сравнения и повторного использования.
        </p>
      </div>
    );
  }

  // Получение символа валюты по проекту
  const getCurrencySymbol = (project) => {
    const currency = project.formData?.currencyType || 'RUB';
    switch (currency) {
      case 'USD': return '$';
      case 'EUR': return '€';
      default: return '₽';
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <Building className="w-5 h-5 mr-2 text-indigo-500" />
          Сохраненные проекты
        </h3>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {savedProjects.length} {savedProjects.length === 1 ? 'проект' : savedProjects.length < 5 ? 'проекта' : 'проектов'}
        </span>
      </div>

      <div className="space-y-4">
        {savedProjects.map((project) => (
          <div 
            key={project.id} 
            className="bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg p-4 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors group"
          >
            <div className="flex justify-between items-start mb-2">
              <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                {project.name}
              </h4>
              <div className="flex items-center space-x-2">
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<Layers className="w-4 h-4" />}
                  onClick={() => loadSavedProject(project.id)}
                  title="Загрузить параметры"
                />
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<Trash2 className="w-4 h-4 text-red-500" />}
                  onClick={() => deleteSavedProject(project.id)}
                  title="Удалить"
                />
              </div>
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              <div className="flex justify-between mb-1">
                <span>Тип проекта:</span>
                <span>
                  {project.results?.projectType || 'Не указан'}
                </span>
              </div>
              <div className="flex justify-between mb-1">
                <span>Площадь:</span>
                <span>
                  {project.formData?.buildingArea || '0'} м²
                </span>
              </div>
              <div className="flex justify-between mb-1">
                <span>Этажность:</span>
                <span>
                  {project.formData?.numFloors || '1'}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Итоговая стоимость:</span>
                <span className="font-semibold text-indigo-600 dark:text-indigo-400">
                  {formatNumber(project.results?.totalCost || 0, 0)} {getCurrencySymbol(project)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SampleProjectsSidebar;